import React from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import QuestionComponent from "./QuestionComponent";
import { v4 as uuidv4 } from "uuid";

export default function DraggableQuestionList({
  questions,
  setQuestions,
  addQuestion,
  deleteQuestion,
  addOption,
  updateQuestion,
  updateOption,
  handleImageUpload,
  categories,
  addNewCategory,
  deleteOption
}) {
  const onBeforeCapture = () => {
    document.body.classList.add("dragging");
  };

  const onDragEnd = (result) => {
    document.body.classList.remove("dragging");
    if (!result.destination) return;

    const reordered = Array.from(questions);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setQuestions(reordered);
  };

  // Duplicate a top-level question including all options and child questions
const duplicateQuestion = (questionId) => {
  // Recursively search in a list of questions
  const duplicateInList = (qs) => {
    return qs.map((q) => {
      // If this is the question to duplicate
      if (q.id === questionId) {
        const clone = { ...q, id: uuidv4() };
        clone.options = clone.options.map((opt) => {
          const newOpt = { ...opt, id: uuidv4() };
          newOpt.childQuestions = opt.childQuestions?.map(duplicateInList) || [];
          return newOpt;
        });
        return [q, clone]; // return original + duplicate
      }

      // Otherwise, look inside options
      const newOptions = q.options.map((opt) => {
        return {
          ...opt,
          childQuestions: duplicateInList(opt.childQuestions || []),
        };
      });

      return { ...q, options: newOptions };
    }).flat(); // flatten because we may return [original, clone]
  };

  setQuestions((prev) => duplicateInList(prev));
};



  return (
    <DragDropContext onDragEnd={onDragEnd} onBeforeCapture={onBeforeCapture}>
      <Droppable droppableId="questions" type="TOP_LEVEL">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {questions.map((q, index) => (
              <Draggable key={q.id} draggableId={q.id} index={index}>
                {(providedDraggable) => (
                  <div
                    ref={providedDraggable.innerRef}
                    {...providedDraggable.draggableProps}
                  >
                    <QuestionComponent
                      question={q}
                      index={index + 1} // Top-level question number
                      depth={0}
                      dragHandleProps={providedDraggable.dragHandleProps}
                      addOption={addOption}
                      addChildQuestion={addQuestion}
                      updateQuestion={updateQuestion}
                      updateOption={updateOption}
                      handleImageUpload={handleImageUpload}
                      allCategories={categories || []}
                      addNewCategory={addNewCategory}
                      deleteQuestion={deleteQuestion}
                      deleteOption={deleteOption}
                      duplicateQuestion={duplicateQuestion} // pass down
                    />
                  </div>
                )}
              </Draggable>
            ))}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
